import type Cookies from 'js-cookie';
import { useCallback, type FC } from 'react';
import CookieContent from '../CookieContent';
import { COOKIE_POLICY_COOKIE_NAME } from '../../constants';
import useCookie from '../../hooks/useCookie';
import useOpenCloseToggle from '../../hooks/useOpenCloseToggle';
import { useRequestInfoContext } from '../../providers/RequestInfoProvider';

const cookieAttributes: Cookies.CookieAttributes = {
  expires: 365 * 10,
  path: '/',
  sameSite: 'Lax',
};

const USEBERRY_IFRAME_HOST = 'https://app.useberry.com';

const GdprCompliance: FC = () => {
  const { showCookieBanner } = useRequestInfoContext();
  const [, setCookie] = useCookie(COOKIE_POLICY_COOKIE_NAME);

  const { isOpen, close } = useOpenCloseToggle(showCookieBanner);
  const handleClose = useCallback(() => {
    const attributes = { ...cookieAttributes };

    // Support cross-site cookies for Useberry, so that users don't
    // get spammed by the cookie banner while testing the site
    if (window.location.ancestorOrigins?.contains(USEBERRY_IFRAME_HOST)) {
      attributes.sameSite = 'None';
      // Required or the cookie won't be set
      attributes.secure = true;
    }
    setCookie('true', attributes);

    close();
  }, [close, setCookie]);

  return isOpen ? (
    <CookieContent
      onClose={handleClose}
    />
  ) : null;
};

export default GdprCompliance;
